/**
 * AWS Cognito rejects USERNAME / userAlias outside `[\p{L}\p{M}\p{S}\p{N}\p{P}]+`.
 * Strip Unicode separators (spaces, NBSP, etc.) and format chars (Cf, e.g. ZWSP).
 *
 * Phone-shaped identifiers (no `@`, digits + common formatting) are collapsed to E.164
 * so values match Cognito `phone_number` / alias storage (e.g. `(310)853-3145` → `+13108533145`).
 */
function stripUnicodeSeparatorsAndFormatChars(s: string): string {
  return s
    .normalize("NFC")
    .trim()
    .replace(/\p{Z}+/gu, "")
    .replace(/\p{Cf}+/gu, "");
}

function looksLikePhoneIdentifier(s: string): boolean {
  if (s.includes("@")) return false;
  const digits = s.replace(/\D/g, "");
  if (digits.length < 7) return false;
  return /^[\d+().\s-]+$/.test(s);
}

/** Mirrors Login `getE164`, including 11-digit US numbers that already include country code 1. */
function digitsToE164(digits: string): string {
  if (!digits) return "";
  if (digits.startsWith("44")) return `+${digits}`;
  if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;
  if (digits.length === 10) return `+1${digits}`;
  return `+${digits}`;
}

export function normalizeCognitoUsername(
  raw: string | null | undefined
): string {
  if (raw == null || typeof raw !== "string") return "";
  const s = stripUnicodeSeparatorsAndFormatChars(raw);
  if (!looksLikePhoneIdentifier(s)) return s;
  return digitsToE164(s.replace(/\D/g, ""));
}
